import { memo } from 'react'

import { PortfolioScreen } from '@root/features/explore-v2/ui/portfolio-screen/portfolio-screen'

/**
 * The account screen in the V2 language, mounted the same way Pulse is: its
 * own screen rather than a page inside the terminal's shell, so none of the
 * old chrome appears around it.
 */
export const PortfolioV2Page: React.FC = memo(() => <PortfolioScreen />)
